<template>
    <div>
        <div class="flex justify-between">
            <div class="w-[35%]">
                <label>From</label>
            </div>
            <div class="w-[35%]">
                <label>To</label>
            </div>
            <div class="w-[30%]"></div>
        </div>
        <div class="flex justify-between flex-wrap mb-2">
            <div class="w-[35%]">
                <div class="form-group date-picker input-left mb-0" :class="{'invalid': dateError}">
                    <date-picker v-model="form.from"
                                 value-type="format"
                                 :type="datePickerType"
                                 :format="dateFormat"
                                 :disabled-date="disabledDate"/>
                </div>
            </div>
            <div class="w-[35%]">
                <div class="form-group date-picker input-center mb-0" :class="{'invalid': dateError}">
                    <date-picker v-model="form.to"
                                 value-type="format"
                                 :type="datePickerType"
                                 :format="dateFormat"
                                 :disabled-date="disabledDate"/>
                </div>
            </div>
            <div class="w-[30%]">
                <button
                    @click="addRange"
                    class="btn btn-blue bg-fully w-full h-[46px] rounded-tl-none rounded-bl-none uppercase">
                    Add
                </button>
            </div>
            <div class="w-[100%] text-red-600 text-[12px]" v-if="dateError">{{ dateError }}</div>
        </div>
    </div>
</template>

<script>
    import { EventBus } from "@widget/plugins/event-bus";
    import DatePicker from "vue2-datepicker";
    import dayjs from "dayjs";
    import "vue2-datepicker/index.css";

    export default {
        name: "date-range",
        props: {
            item: {
                type: Object,
                require: true,
                default: () => {
                    return {};
                }
            }
        },
        components: {
            DatePicker
        },
        computed: {
            config () {
                return this.item.config ? this.item.config : this.item.widget_config;
            },
            dateFormat () {
                if (this.config.day) {
                    return "YYYY-MM-DD";
                } else if (this.config.month) {
                    return "YYYY-MM";
                } else {
                    return "YYYY";
                }
            },
            dateFormatUI () {
                if (this.config.day) {
                    return "DD MMM, YYYY";
                } else if (this.config.month) {
                    return "MMM, YYYY";
                } else {
                    return "YYYY";
                }
            },
            datePickerType () {
                if (this.config.day) {
                    return "date";
                } else if (this.config.month) {
                    return "month";
                } else {
                    return "year";
                }
            },
            checkSelectStore () {
                let selectStore = this.$store.getters["widgetData/getSelectByCode"](this.item.code);
                return !!(selectStore &&
                    !dayjs(selectStore.query[0]).diff(dayjs(this.form.from)) &&
                    !dayjs(selectStore.query[1]).diff(dayjs(this.form.to)));

            }
        },
        methods: {
            addRange () {
                if (this.checkSelectStore) return;

                this.dateError = null;

                let dateFrom = dayjs(this.form.from);
                let dateTo = dayjs(this.form.to);

                if (!this.form.from || !this.form.to) {
                    this.dateError = "Select dates";
                    return;
                }

                if (dateFrom.diff(dateTo, "days") > 0) {
                    this.dateError = "'Date To' must be upper 'Date From'";
                    return;
                }

                this.$store.commit("widgetData/addSelect", {
                    sensitive: this.item.attentionText !== "",
                    code: this.item.code,
                    group: this.item.group,
                    title: `${this.item.title}: ${dayjs(this.form.from).format(this.dateFormatUI)} - ${dayjs(this.form.to).format(this.dateFormatUI)}`,
                    query: [this.form.from, this.form.to]
                });
            },
            disabledDate (date) {
                let dateFrom, dateTo;
                if (this.config.type === "abs") {
                    dateFrom = this.config.min ? dayjs(this.config.min, this.config.format).format(this.dateFormat) : 1900;
                    dateTo = this.config.max ? dayjs(this.config.max, this.config.format).format(this.dateFormat) : dayjs().format(this.dateFormat);
                } else {
                    dateFrom = this.config.min ? dayjs().subtract(this.getParseDate("min").year, "years").format(this.dateFormat) : 1900;
                    dateTo = this.config.max ? dayjs().subtract(this.getParseDate("max").year, "years").format(this.dateFormat) : dayjs().format(this.dateFormat);
                }
                return date < dayjs(dateFrom) || date > dayjs(dateTo);
            },
            getParseDate (type = "min") {
                let data = type === "min" ? this.config.max : this.config.min;
                let match = /[0-9]{2}/g;
                if (this.config.type === "abs") {
                    data = type === "min" ? this.config.min : this.config.max;
                    match = /[0-9]{4}|[0-9]{2}/g;
                }

                if (!data) return false;
                let parse = data.match(match);
                return {
                    year: parse[0],
                    month: parse[1],
                    day: parse[2]
                };
            }
        },
        created () {
            if (this.config.type === "abs") {
                this.form.from = this.config.min ? dayjs(`${this.getParseDate("min").year}-${this.getParseDate("min").month}-${this.getParseDate("min").day}`).format(this.dateFormat) : 1900;
                this.form.to = this.config.max ? dayjs(`${this.getParseDate("max").year}-${this.getParseDate("max").month}-${this.getParseDate("max").day}`).format(this.dateFormat) : dayjs().format(this.dateFormat);
            } else {
                this.form.from = this.config.min ? dayjs().subtract(this.getParseDate("min").year, "years").format(this.dateFormat) : 1900;
                this.form.to = this.config.max ? dayjs().subtract(this.getParseDate("max").year, "years").format(this.dateFormat) : dayjs().format(this.dateFormat);
            }
        },
        mounted () {
            EventBus.$on("load-local-storage", () => {
                let storeSelect = this.$store.getters["widgetData/getSelectByCode"](this.item.code);
                if (storeSelect) {
                    this.form.from = storeSelect.query[0];
                    this.form.to = storeSelect.query[1];

                    this.$emit("open");
                }
            });

            EventBus.$on("remove-select", (code) => {
                if (code === this.code) {
                    if (this.config.type === "abs") {
                        this.form.from = this.config.min ? dayjs(`${this.getParseDate("min").year}-${this.getParseDate("min").month}-${this.getParseDate("min").day}`).format(this.dateFormat) : 1900;
                        this.form.to = this.config.max ? dayjs(`${this.getParseDate("max").year}-${this.getParseDate("max").month}-${this.getParseDate("max").day}`).format(this.dateFormat) : dayjs().format(this.dateFormat);
                    } else {
                        this.form.from = this.config.min ? dayjs().subtract(this.getParseDate("min").year, "years").format(this.dateFormat) : 1900;
                        this.form.to = this.config.max ? dayjs().subtract(this.getParseDate("max").year, "years").format(this.dateFormat) : dayjs().format(this.dateFormat);
                    }

                    this.$emit("close");
                }
            });

            EventBus.$on("clear-all", () => {
                if (this.config.type === "abs") {
                    this.form.from = this.config.min ? dayjs(`${this.getParseDate("min").year}-${this.getParseDate("min").month}-${this.getParseDate("min").day}`).format(this.dateFormat) : 1900;
                    this.form.to = this.config.max ? dayjs(`${this.getParseDate("max").year}-${this.getParseDate("max").month}-${this.getParseDate("max").day}`).format(this.dateFormat) : dayjs().format(this.dateFormat);
                } else {
                    this.form.from = this.config.min ? dayjs().subtract(this.getParseDate("min").year, "years").format(this.dateFormat) : 1900;
                    this.form.to = this.config.max ? dayjs().subtract(this.getParseDate("max").year, "years").format(this.dateFormat) : dayjs().format(this.dateFormat);
                }

                this.$emit("close");
            });
        },
        data () {
            return {
                form: {
                    from: null,
                    to: null
                },
                dateError: null
            };
        }
    };
</script>
